import Zone from "@insite/client-framework/Components/Zone";
import PageModule from "@insite/client-framework/Types/PageModule";
import PageProps from "@insite/client-framework/Types/PageProps";
import Page, { PageProps as MobiusPageProps } from "@insite/mobius/Page";
import { BaseTheme } from "@insite/mobius/globals/baseTheme";
import breakpointMediaQueries from "@insite/mobius/utilities/breakpointMediaQueries";
import React from "react";
import { css } from "styled-components";
import {
    ExcludeFromNavigation,
    ExcludeFromSignInRequired,
    HideFooter,
    HideHeader,
    MetaDescription,
    MetaKeywords,
    OpenGraphImage,
    OpenGraphTitle,
    OpenGraphUrl,
} from "@insite/client-framework/Types/FieldDefinition";

export interface NoSearchResultPageStyles {
    page?: MobiusPageProps;
}

export const noSearchResultPageStyles: NoSearchResultPageStyles = {
    page: {
        css: css`
            padding-bottom: 24px !important;
            .twoColumnWrapper {
                > div {
                    gap: 24px;
                }
            }
            .img-wrapper {
                display: flex;
            }
            .product-expanded-grid-carousel {
                margin-top: 24px !important;
                width: calc(100% + 32px);
                margin: 0 -16px;
            }
            ${({ theme }: { theme: BaseTheme }) =>
            breakpointMediaQueries(
                theme,
                [
                    null,
                    null,
                    css`
                        .topWrapper {
                            max-width: 1120px;
                        }
                        .twoColumnWrapperItem {
                            align-items: center;
                        }
                        .twoColumnWrapper {
                            > div {
                                gap: 40px;
                                flex-wrap: nowrap;
                            }
                        }
                    `,
                    css`
                        .product-expanded-grid-carousel {
                            width: calc(100% + 48px);
                            margin: 0 -24px;
                        }
                    `
                ],
                "min",
            )}
        `
    }

}

const styles = noSearchResultPageStyles;

const NoSearchResultPage = ({ id }: PageProps) => {
    return (
        <Page {...styles.page}>
            <Zone contentId={id} zoneName="Content"></Zone>
        </Page>
    );
};

const pageModule: PageModule = {
    component: NoSearchResultPage,
    definition: {
        hasEditableUrlSegment: true,
        hasEditableTitle: true,
        pageType: "Content",
        fieldDefinitions: [        
            MetaKeywords,
            MetaDescription,
            OpenGraphTitle,
            OpenGraphUrl,
            OpenGraphImage,
            HideHeader,
            HideFooter,
            ExcludeFromNavigation,
            ExcludeFromSignInRequired,
        ],
    },
};

export default pageModule;
